import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { injectBreakpoint } from '@seatix/shared-config';
import { UiIconComponent } from '@seatix/shared/ui/ui-icons';

/**
 * The line of context a checkout header shows above the countdown: what is
 * being bought, when, and where.
 *
 * Takes plain strings rather than an event, because what a buyer is paying for
 * is not always an event — a season pass has a name and a venue but no single
 * date of its own. The caller decides how each field reads; this only lays them
 * out.
 */
@Component({
  selector: 'stx-event-header-info',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiIconComponent],
  host: {
    class: 'flex flex-col',
  },
  template: `
    <div class="min-w-0 max-w-full truncate text-sm font-semibold lg:text-lg">
      <span class="block min-w-0 max-w-full truncate">{{ title() }}</span>
    </div>
    <div
      class="flex flex-col text-xs sm:text-sm lg:flex-row lg:items-start lg:gap-4 lg:text-base"
    >
      <div class="flex min-w-0 max-w-full items-center gap-1">
        <stx-ui-icon
          name="calendar"
          [size]="iconSize()"
        />
        <p class="line-clamp-1 block min-w-0 overflow-hidden truncate">
          {{ dateText() }}
        </p>
      </div>
      <span class="flex items-center gap-1">
        <stx-ui-icon
          name="mapPin"
          [size]="iconSize()"
        />
        {{ venueName() }}
      </span>
    </div>
  `,
})
export class EventHeaderInfoComponent {
  readonly title = input.required<string>();
  readonly dateText = input('');
  readonly venueName = input<string | null>(null);
  screenMd = injectBreakpoint('md');
  readonly iconSize = computed(() => (!this.screenMd() ? '18' : '24'));
}
